// assets/swiper-loader.js
(function() {
  window.SwiperLoader = window.SwiperLoader || {
    _queue: [],
    _ready: false,
    
    onReady: function(callback) {
      if (this._ready || typeof Swiper !== 'undefined') {
        this._ready = true;
        callback(window.Swiper);
        return;
      }
      this._queue.push(callback);
      this._poll();
    },
    
    _poll: function() {
      if (this._polling) return;
      this._polling = true;
      
      const interval = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(interval);
          this._ready = true;
          this._polling = false;
          const callbacks = this._queue.slice();
          this._queue.length = 0;
          callbacks.forEach(cb => cb(window.Swiper));
        }
      }, 50);
      
      // Give up after 10 seconds
      setTimeout(() => {
        clearInterval(interval);
        if (!this._ready) {
          console.error('[SwiperLoader] Swiper failed to load after 10s');
        }
      }, 10000);
    }
  };
})();